// CSS
import "unpoly/unpoly.css";
import "@css/app.scss";

import 'what-input';

// Our App
import { initResizeEvents } from "@/libs/helpers";

import "@/parts/lazyloading";
import "@/parts/hero-carousel";
import "@/parts/exposure-gallery";
import "@/parts/hero-slideshow";
import "@/parts/mailchimp";

initResizeEvents();

/**
 * Unpoly
 */
import "@/parts/unpoly/index";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import "@/parts/alpine/index";

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}
